import Moment from 'moment';
import { FC } from 'react';

type Date = {
  date: Date;
};

export const FormatDate: FC<Date> = ({ date }) => {
  return Moment(date).format('DD/MM/YYYY');
};
